// extracted by mini-css-extract-plugin
module.exports = {"table":"List_style_table__1WbzN"};